import { Auth } from '../types'
import { useState } from '#app'

export function useAuth () {
  return useState('auth').value as Auth
}
